import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import { Link, Route, withRouter, Switch, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import CaseInformation from "./CaseInformation";
import EnquirySubmission from "./EnquirySubmission";
import ArbitratorNotice from "./ArbitratorNotice";
import Grid from "@material-ui/core/Grid";
import Award from "./Award";
import Button from "@material-ui/core/Button";
import TeleConferencing from "./TeleConferencing";
import DocsList from "./DocsList";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import PrimaryAppBar from "../../components/PrimaryAppBar";
import Settlement from "./Settlement";
import Response from "./Response";
import CircularProgress from "@material-ui/core/CircularProgress";
import withSizes from "react-sizes";
import ChooseArbitratorForCaseInformation from "./ChooseArbitratorForCaseInformation";

import Footer from "../../containers/Footer/Footer";

import searchBtn from "../../../src/images/searchBtn.png";
import awardBtn from "../../../src/images/awardBtn.png";
import settlementBtn from "../../../src/images/settlementBtn.png";
import responseBtn from "../../../src/images/responseBtn.png";
import uploadDocBtn from "../../../src/images/uploadDocBtn.png";
import arbitrationNoticeBtn from "../../../src/images/arbitrationNoticeBtn.png";
import caseInfoBtn from "../../../src/images/caseInfoBtn.png";
import appointArbitrator from "../../../src/images/appointArbitrator.png"; 

import searchBtnEng from "../../../src/images/searchBtnEng.png";
import awardBtnEng from "../../../src/images/awardBtnEng.png";
import settlementBtnEng from "../../../src/images/settlementBtnEng.png";
import responseBtnEng from "../../../src/images/responseBtnEng.png";
import uploadDocBtnEng from "../../../src/images/uploadDocBtnEng.png";
import arbitrationNoticeBtnEng from "../../../src/images/arbitrationNoticeBtnEng.png";
import caseInfoBtnEng from "../../../src/images/caseInfoBtnEng.png";
import appointArbitratorEng from "../../../src/images/appointArbitratorEng.png"; 

const styles = (theme) => ({
  isMobileFormControl: {
    marginLeft: "auto",
    marginRight: "auto",
  },
  active_tabStyle: {
    color: "white",
    backgroundColor: "#B71C1C",
    outline: "0",
  },
  root: {
    width: "100vw",
  },
  [theme.breakpoints.down("xs")]: {
    tabLabel: {
      fontSize: 12,
    },
  },
  [theme.breakpoints.up("sm")]: {
    tabLabel: {
      fontSize: 12,
    },
  },
  [theme.breakpoints.up("md")]: {
    tabLabel: {
      fontSize: 12,
    },
  },
  btn:{
      marginBottom:'10px'
  },
  btnimg:{
      width:'100%'
  },
  gri:{
  }
});

function TabContainer(props) {
  return <Typography component="div">{props.children}</Typography>;
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

function LinkTab(props) {
  return <Tab component={Link} {...props} />;
}

class MainPanel extends Component {
  state = {
    tab: "",
    value: undefined,
    typeOfAccount: localStorage.getItem("typeOfAccount"),
    windowHeight: undefined,
    windowWidth: undefined
  };

  handleResize = () => {
    this.setState({
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth
    })
  } 

  componentDidUpdate() {}

  checkLanguage = function() {
    // try{
    //   if (this.props.isLoading){
    //     setTimeout(()=>{this.checkLanguage()},100)
    //   }
    //   else{
    //     console.log('this caseData: '+JSON.stringify(this.props.caseData))
    //     var lang = localStorage.getItem('language');
    //     if (this.props !== undefined){
    //       if (this.props.caseData !== undefined){
    //         if (this.props.caseData.language !== undefined){
    //           if (this.props.caseData.language == 'Chi'){
    //             if (lang == 'en' || lang == undefined){
    //               localStorage.setItem('language', 'cn');
    //               setTimeout(()=>{
    //                   window.location.reload();
    //               },100)
    //             }
    //           }
    //           else if (this.props.caseData.language == 'Eng'){
    //             if (lang == 'cn' || lang == undefined){
    //               localStorage.setItem('language', 'en');
    //               setTimeout(()=>{
    //                   window.location.reload();
    //               },100)
    //             }
    //           }
    //         }
    //       }
    //     }
    //   }
    // }catch(err){
    //   setTimeout(()=>{this.checkLanguage()},100)
    // }
  };

  componentDidMount() {
    console.log(
      "localStorage.getItem(caseId): " + localStorage.getItem("caseId")
    );
    console.log(
      "localStorage.getItem(token): " + localStorage.getItem("token")
    );

    this.handleResize();
    window.addEventListener('resize', this.handleResize)
    this.props.getCaseInfo(localStorage.getItem('caseId'), localStorage.getItem('token'));
    this.props.getUserInformation(localStorage.getItem('token'));
    this.checkLanguage();
  }

  componentWillMount() {
    window.removeEventListener('resize', this.handleResize)
    // console.log('localStorage.getItem(caseId): '+localStorage.getItem('caseId'))
    // console.log('localStorage.getItem(token): '+localStorage.getItem('token'))
    this.props.getCaseInfo(localStorage.getItem('caseId'), localStorage.getItem('token'));
    this.props.getUserInformation(localStorage.getItem('token'));
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeSelect = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
        const { classes } = this.props;
        const { value } = this.state;

        console.log(`### MainPanel render this.state.this.props.admin_docs ${this.props.admin_docs}`);
        // if(!this.props.isAuthenticated){
        //     return(<Redirect to='/' />)
        // }
        const twofa = localStorage.getItem('twofa');
        if(this.props.isLoading){
            return(<CircularProgress size={50} thickness={3} className={classes.progress}/>)
        }
        else{
            
            if(this.props.newAccount !== null && this.props.newAccount !== undefined && this.props.newAccount && twofa){
                return(<Redirect to={`/cases/${this.props.match.params.id}/OnBoarding`} />)
            }

            if (this.props.isDesktop){
                
                if (this.state.typeOfAccount == 'arbitrator'){          
                    return(
                        <div className={classes.root}>
                            <PrimaryAppBar />
                            {value == undefined && <Grid container spacing={0} 
                            style={{
                                paddingLeft: (!this.props.isMobile) ? (this.state.windowWidth > 900 ? '300px':'') : '',
                                paddingRight: (!this.props.isMobile) ? (this.state.windowWidth > 900 ? '300px':'') : '',
                            }}>
                            
                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 0)}}>
                                <img className={classes.btnimg} src={this.props.lang == 'cn'?caseInfoBtn:caseInfoBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 1)}}>
                                <img className={classes.btnimg}  src={this.props.lang == 'cn'?arbitrationNoticeBtn : arbitrationNoticeBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 2)}}>
                                <img className={classes.btnimg}  src={this.props.lang == 'cn'?responseBtn : responseBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 3)}}>
                                <img className={classes.btnimg}  src={this.props.lang == 'cn'?uploadDocBtn: uploadDocBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 7)}}>
                                <img className={classes.btnimg}  src={this.props.lang == 'cn'?appointArbitrator: appointArbitratorEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 5)}}>
                                <img className={classes.btnimg}  src={this.props.lang == 'cn'?searchBtn: searchBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 6)}}>
                                <img className={classes.btnimg}  src={this.props.lang == 'cn'?awardBtn: awardBtnEng}></img>
                                </Button>
                            </Grid>

                            </Grid>}

                                {value === 0 && <CaseInformation handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                {value === 1 && <ArbitratorNotice handleChange={this.handleChange}/>}
                                {value === 2 && <Response handleChange={this.handleChange}/>}
                                {value === 3 && <DocsList handleChange={this.handleChange} caseData={this.props.caseData} docs={{ claimant_docs: this.props.claimant_docs, respondent_docs: this.props.respondent_docs, admin_docs: this.props.admin_docs }} showUploadDocs={this.props.userType ==='All'} />}
                                {value === 4 && <Settlement handleChange={this.handleChange}/>}
                                {value === 5 && <EnquirySubmission handleChange={this.handleChange}/>}
                                {value === 6 && <Award handleChange={this.handleChange}/>}
                                {value === 7 && <ChooseArbitratorForCaseInformation handleChange={this.handleChange} caseData={this.props.caseData}/>}

                            {this.props.isDesktop && <Footer />}
                        </div>
                    );
                }
                else if (this.state.typeOfAccount == 'admin'){
                    return(
                        <div className={classes.root}>
                            <PrimaryAppBar />
                            {value == undefined && <Grid container spacing={0} 
                            style={{
                                paddingLeft: (!this.props.isMobile) ? (this.state.windowWidth > 900 ? '300px':'') : '',
                                paddingRight: (!this.props.isMobile) ? (this.state.windowWidth > 900 ? '300px':'') : '',
                            }}>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 0)}}>
                                <img className={classes.btnimg} src={this.props.lang == 'cn'?caseInfoBtn : caseInfoBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 1)}}>
                                <img className={classes.btnimg}  src={this.props.lang == 'cn'?arbitrationNoticeBtn : arbitrationNoticeBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 2)}}>
                                <img className={classes.btnimg}  src={this.props.lang == 'cn'?responseBtn : responseBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 3)}}>
                                <img className={classes.btnimg} src={this.props.lang == 'cn'?uploadDocBtn: uploadDocBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 7)}}>
                                <img className={classes.btnimg} src={this.props.lang == 'cn'?appointArbitrator: appointArbitratorEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 4)}}>
                                <img className={classes.btnimg} src={this.props.lang == 'cn'?settlementBtn: settlementBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 5)}}>
                                <img className={classes.btnimg} src={this.props.lang == 'cn'?searchBtn: searchBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 6)}}>
                                <img className={classes.btnimg} src={this.props.lang == 'cn'?awardBtn: awardBtnEng}></img>
                                </Button>
                            </Grid>

                            
                            
                            </Grid>}

                                {value === 0 && <CaseInformation handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                {value === 1 && <ArbitratorNotice handleChange={this.handleChange}/>}
                                {value === 2 && <Response handleChange={this.handleChange}/>}
                                {value === 3 && <DocsList handleChange={this.handleChange} caseData={this.props.caseData} docs={{ claimant_docs: this.props.claimant_docs, respondent_docs: this.props.respondent_docs, admin_docs: this.props.admin_docs }} showUploadDocs={this.props.userType ==='All'} />}
                                {value === 4 && <Settlement handleChange={this.handleChange}/>}
                                {value === 5 && <EnquirySubmission handleChange={this.handleChange}/>}
                                {value === 6 && <Award handleChange={this.handleChange}/>}
                                {value === 7 && <ChooseArbitratorForCaseInformation handleChange={this.handleChange} caseData={this.props.caseData}/>}

                            {this.props.isDesktop && <Footer />}
                        </div>
                    );
                }
                else if (this.state.typeOfAccount == 'user'){
                    if (this.props.caseData !== undefined && this.props.caseData !== null){
                        if (this.props.caseData.teleconferencing !== undefined){
                            if (this.props.caseData.teleconferencing == true){

                                return (
                                <div>
                                    <PrimaryAppBar />
                                    {value == undefined && <Grid container spacing={0} 
                                    style={{
                                        paddingLeft: (!this.props.isMobile) ? (this.state.windowWidth > 900 ? '300px':'') : '',
                                        paddingRight: (!this.props.isMobile) ? (this.state.windowWidth > 900 ? '300px':'') : '',
                                    }}>

                                    <Grid item xs={3}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 0)}}>
                                        <img className={classes.btnimg} src={this.props.lang == 'cn'?caseInfoBtn:caseInfoBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 1)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?arbitrationNoticeBtn : arbitrationNoticeBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 2)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?responseBtn : responseBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 3)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?uploadDocBtn: uploadDocBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 7)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?appointArbitrator: appointArbitratorEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 4)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?settlementBtn: settlementBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 5)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?searchBtn: searchBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 6)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?awardBtn: awardBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    
                                    
                                    </Grid>}

                                        {value === 0 && <CaseInformation handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 1 && <ArbitratorNotice handleChange={this.handleChange} />}
                                        {value === 2 && <Response handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 3 && <DocsList handleChange={this.handleChange} caseData={this.props.caseData} docs={{ claimant_docs: this.props.claimant_docs, respondent_docs: this.props.respondent_docs, admin_docs: this.props.admin_docs }} showUploadDocs={this.props.userType ==='All'} />}
                                        {value === 4 && <Settlement handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 5 && <EnquirySubmission handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 6 && <Award handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 7 && <ChooseArbitratorForCaseInformation handleChange={this.handleChange} caseData={this.props.caseData}/>}

                                    {this.props.isDesktop && <Footer />}
                                </div>
                                );
                        }
                        else{
                            return(
                                <div className={classes.root}>
                                    <PrimaryAppBar />
                                    {value == undefined && <Grid container spacing={0} 
                                    style={{
                                        paddingLeft: (!this.props.isMobile) ? (this.state.windowWidth > 900 ? '300px':'') : '',
                                        paddingRight: (!this.props.isMobile) ? (this.state.windowWidth > 900 ? '300px':'') : '',
                                    }}>

                                    <Grid item xs={3}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 0)}}>
                                        <img className={classes.btnimg} src={this.props.lang == 'cn'?caseInfoBtn:caseInfoBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 1)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?arbitrationNoticeBtn : arbitrationNoticeBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 2)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?responseBtn : responseBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 3)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?uploadDocBtn: uploadDocBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e,7)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?appointArbitrator: appointArbitratorEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 4)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?settlementBtn: settlementBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 5)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?searchBtn: searchBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 6)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?awardBtn: awardBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    
                                    
                                    </Grid>}
                                        {value === 0 && <CaseInformation handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 1 && <ArbitratorNotice handleChange={this.handleChange}/>}
                                        {value === 2 && <Response handleChange={this.handleChange}/>}
                                        {value === 3 && <DocsList handleChange={this.handleChange} caseData={this.props.caseData} docs={{ claimant_docs: this.props.claimant_docs, respondent_docs: this.props.respondent_docs, admin_docs: this.props.admin_docs }} showUploadDocs={this.props.userType ==='All'} />}
                                        {value === 4 && <Settlement handleChange={this.handleChange}/>}
                                        {value === 5 && <EnquirySubmission handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 6 && <Award handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 7 && <ChooseArbitratorForCaseInformation handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                    {this.props.isDesktop && <Footer />}
                                </div>
                            );
                        }
                    }
                    else{
                        return(
                            <div className={classes.root}>
                                <PrimaryAppBar />
                                {value == undefined && <Grid container spacing={0} 
                                    style={{
                                        paddingLeft: (!this.props.isMobile) ? (this.state.windowWidth > 900 ? '300px':'') : '',
                                        paddingRight: (!this.props.isMobile) ? (this.state.windowWidth > 900 ? '300px':'') : '',
                                    }}>

                                    <Grid item xs={3}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 0)}}>
                                        <img className={classes.btnimg} src={this.props.lang == 'cn'?caseInfoBtn:caseInfoBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 1)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?arbitrationNoticeBtn : arbitrationNoticeBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 2)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?responseBtn : responseBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 3)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?uploadDocBtn: uploadDocBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 7)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?appointArbitrator: appointArbitratorEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 4)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?settlementBtn: settlementBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 5)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?searchBtn: searchBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 6)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?awardBtn: awardBtnEng}></img>
                                        </Button>
                                    </Grid>

                                   
                                    
                                    </Grid>}
                                        {value === 0 && <CaseInformation handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 1 && <ArbitratorNotice handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 2 && <Response handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 3 && <DocsList handleChange={this.handleChange} caseData={this.props.caseData} docs={{ claimant_docs: this.props.claimant_docs, respondent_docs: this.props.respondent_docs, admin_docs: this.props.admin_docs }} showUploadDocs={this.props.userType ==='All'} />}
                                        {value === 4 && <Settlement handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 5 && <EnquirySubmission handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 6 && <Award handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 7 && <ChooseArbitratorForCaseInformation handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                    {this.props.isDesktop && <Footer />}
                            </div>
                        );
                    }
                }
                else{
                    return(
                        <div className={classes.button}>
                            <CircularProgress size={25} thickness={2} className={classes.loading}/>
                        </div>
                    )

                }

                }
            }
            else{
                if (this.state.typeOfAccount == 'arbitrator'){          
                    return(
                        <div className={classes.root}>
                            <PrimaryAppBar />
                            {value == undefined && <Grid container spacing={0} 
                            style={{
                                paddingLeft: (!this.props.isMobile) ? (this.state.windowWidth > 900 ? '300px':'') : '',
                                paddingRight: (!this.props.isMobile) ? (this.state.windowWidth > 900 ? '300px':'') : '',
                            }}>
                            
                            <Grid item xs={6}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 0)}}>
                                <img className={classes.btnimg} src={this.props.lang == 'cn'?caseInfoBtn:caseInfoBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={6}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 1)}}>
                                <img className={classes.btnimg}  src={this.props.lang == 'cn'?arbitrationNoticeBtn : arbitrationNoticeBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={6}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 2)}}>
                                <img className={classes.btnimg}  src={this.props.lang == 'cn'?responseBtn : responseBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={6}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 3)}}>
                                <img className={classes.btnimg}  src={this.props.lang == 'cn'?uploadDocBtn: uploadDocBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={6}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 7)}}>
                                <img className={classes.btnimg}  src={this.props.lang == 'cn'?appointArbitrator: appointArbitratorEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={6}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 5)}}>
                                <img className={classes.btnimg}  src={this.props.lang == 'cn'?searchBtn: searchBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={6}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 6)}}>
                                <img className={classes.btnimg}  src={this.props.lang == 'cn'?awardBtn: awardBtnEng}></img>
                                </Button>
                            </Grid>

                            
                            
                            </Grid>}

                                {value === 0 && <CaseInformation handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                {value === 1 && <ArbitratorNotice handleChange={this.handleChange}/>}
                                {value === 2 && <Response handleChange={this.handleChange}/>}
                                {value === 3 && <DocsList handleChange={this.handleChange} caseData={this.props.caseData} docs={{ claimant_docs: this.props.claimant_docs, respondent_docs: this.props.respondent_docs, admin_docs: this.props.admin_docs }} showUploadDocs={this.props.userType ==='All'} />}
                                {value === 4 && <Settlement handleChange={this.handleChange}/>}
                                {value === 5 && <EnquirySubmission handleChange={this.handleChange}/>}
                                {value === 6 && <Award handleChange={this.handleChange}/>}
                                {value === 7 && <ChooseArbitratorForCaseInformation handleChange={this.handleChange} caseData={this.props.caseData}/>}

                            {this.props.isDesktop && <Footer />}
                        </div>
                    );
                }
                else if (this.state.typeOfAccount == 'admin'){
                    return(
                        <div className={classes.root}>
                            <PrimaryAppBar />
                            {value == undefined && <Grid container spacing={0} 
                            style={{
                                paddingLeft: (!this.props.isMobile) ? (this.state.windowWidth > 900 ? '300px':'') : '',
                                paddingRight: (!this.props.isMobile) ? (this.state.windowWidth > 900 ? '300px':'') : '',
                            }}>

                            <Grid item xs={6}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 0)}}>
                                <img className={classes.btnimg} src={this.props.lang == 'cn'?caseInfoBtn : caseInfoBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={6}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 1)}}>
                                <img className={classes.btnimg}  src={this.props.lang == 'cn'?arbitrationNoticeBtn : arbitrationNoticeBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={6}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 2)}}>
                                <img className={classes.btnimg}  src={this.props.lang == 'cn'?responseBtn : responseBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={6}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 3)}}>
                                <img className={classes.btnimg} src={this.props.lang == 'cn'?uploadDocBtn: uploadDocBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={6}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 7)}}>
                                <img className={classes.btnimg} src={this.props.lang == 'cn'?appointArbitrator: appointArbitratorEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={6}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 4)}}>
                                <img className={classes.btnimg} src={this.props.lang == 'cn'?settlementBtn: settlementBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={6}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 5)}}>
                                <img className={classes.btnimg} src={this.props.lang == 'cn'?searchBtn: searchBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={6}>
                                <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 6)}}>
                                <img className={classes.btnimg} src={this.props.lang == 'cn'?awardBtn: awardBtnEng}></img>
                                </Button>
                            </Grid>

                           
                            
                            </Grid>}

                                {value === 0 && <CaseInformation handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                {value === 1 && <ArbitratorNotice handleChange={this.handleChange}/>}
                                {value === 2 && <Response handleChange={this.handleChange}/>}
                                {value === 3 && <DocsList handleChange={this.handleChange} caseData={this.props.caseData} docs={{ claimant_docs: this.props.claimant_docs, respondent_docs: this.props.respondent_docs, admin_docs: this.props.admin_docs }} showUploadDocs={this.props.userType ==='All'} />}
                                {value === 4 && <Settlement handleChange={this.handleChange}/>}
                                {value === 5 && <EnquirySubmission handleChange={this.handleChange}/>}
                                {value === 6 && <Award handleChange={this.handleChange}/>}
                                {value === 7 && <ChooseArbitratorForCaseInformation handleChange={this.handleChange} caseData={this.props.caseData}/>}

                            {this.props.isDesktop && <Footer />}
                        </div>
                    );
                }
                else if (this.state.typeOfAccount == 'user'){
                    if (this.props.caseData !== undefined && this.props.caseData !== null){
                        if (this.props.caseData.teleconferencing !== undefined){
                            if (this.props.caseData.teleconferencing == true){

                                return (
                                <div>
                                    <PrimaryAppBar />
                                    {value == undefined && <Grid  container spacing={0} 
                                    style={{
                                        paddingLeft: (!this.props.isMobile) ? (this.state.windowWidth > 900 ? '300px':'') : '',
                                        paddingRight: (!this.props.isMobile) ? (this.state.windowWidth > 900 ? '300px':'') : '',
                                    }}>

                                    <Grid item xs={6}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 0)}}>
                                        <img className={classes.btnimg} src={this.props.lang == 'cn'?caseInfoBtn:caseInfoBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 1)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?arbitrationNoticeBtn : arbitrationNoticeBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 2)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?responseBtn : responseBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 3)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?uploadDocBtn: uploadDocBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 7)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?appointArbitrator: appointArbitratorEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 4)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?settlementBtn: settlementBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 5)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?searchBtn: searchBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 6)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?awardBtn: awardBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    
                                    
                                    </Grid>}

                                        {value === 0 && <CaseInformation handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 1 && <ArbitratorNotice handleChange={this.handleChange} />}
                                        {value === 2 && <Response handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 3 && <DocsList handleChange={this.handleChange} caseData={this.props.caseData} docs={{ claimant_docs: this.props.claimant_docs, respondent_docs: this.props.respondent_docs, admin_docs: this.props.admin_docs }} showUploadDocs={this.props.userType ==='All'} />}
                                        {value === 4 && <Settlement handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 5 && <EnquirySubmission handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 6 && <Award handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 7 && <ChooseArbitratorForCaseInformation handleChange={this.handleChange} caseData={this.props.caseData}/>}

                                    {this.props.isDesktop && <Footer />}
                                </div>
                                );
                        }
                        else{
                            return(
                                <div className={classes.root}>
                                    <PrimaryAppBar />
                                    {value == undefined && <Grid container spacing={0} 
                                    style={{
                                        paddingLeft: (!this.props.isMobile) ? (this.state.windowWidth > 900 ? '300px':'') : '',
                                        paddingRight: (!this.props.isMobile) ? (this.state.windowWidth > 900 ? '300px':'') : '',
                                    }}>

                                    <Grid item xs={6}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 0)}}>
                                        <img className={classes.btnimg} src={this.props.lang == 'cn'?caseInfoBtn:caseInfoBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 1)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?arbitrationNoticeBtn : arbitrationNoticeBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 2)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?responseBtn : responseBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 3)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?uploadDocBtn: uploadDocBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e,7)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?appointArbitrator: appointArbitratorEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 4)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?settlementBtn: settlementBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 5)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?searchBtn: searchBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 6)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?awardBtn: awardBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    
                                    
                                    </Grid>}
                                        {value === 0 && <CaseInformation handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 1 && <ArbitratorNotice handleChange={this.handleChange}/>}
                                        {value === 2 && <Response handleChange={this.handleChange}/>}
                                        {value === 3 && <DocsList handleChange={this.handleChange} caseData={this.props.caseData} docs={{ claimant_docs: this.props.claimant_docs, respondent_docs: this.props.respondent_docs, admin_docs: this.props.admin_docs }} showUploadDocs={this.props.userType ==='All'} />}
                                        {value === 4 && <Settlement handleChange={this.handleChange}/>}
                                        {value === 5 && <EnquirySubmission handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 6 && <Award handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 7 && <ChooseArbitratorForCaseInformation handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                    {this.props.isDesktop && <Footer />}
                                </div>
                            );
                        }
                    }
                    else{
                        return(
                            <div className={classes.root}>
                                <PrimaryAppBar />
                                {value == undefined && <Grid container spacing={0} 
                                    style={{
                                        paddingLeft: (!this.props.isMobile) ? (this.state.windowWidth > 900 ? '300px':'') : '',
                                        paddingRight: (!this.props.isMobile) ? (this.state.windowWidth > 900 ? '300px':'') : '',
                                    }}>

                                    <Grid item xs={6}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 0)}}>
                                        <img className={classes.btnimg} src={this.props.lang == 'cn'?caseInfoBtn:caseInfoBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 1)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?arbitrationNoticeBtn : arbitrationNoticeBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 2)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?responseBtn : responseBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 3)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?uploadDocBtn: uploadDocBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 7)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?appointArbitrator: appointArbitratorEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 4)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?settlementBtn: settlementBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 5)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?searchBtn: searchBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button className={classes.btn} onClick={(e)=>{this.handleChange(e, 6)}}>
                                        <img className={classes.btnimg}  src={this.props.lang == 'cn'?awardBtn: awardBtnEng}></img>
                                        </Button>
                                    </Grid>

                                    
                                    
                                    </Grid>}
                                        {value === 0 && <CaseInformation handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 1 && <ArbitratorNotice handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 2 && <Response handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 3 && <DocsList handleChange={this.handleChange} caseData={this.props.caseData} docs={{ claimant_docs: this.props.claimant_docs, respondent_docs: this.props.respondent_docs, admin_docs: this.props.admin_docs }} showUploadDocs={this.props.userType ==='All'} />}
                                        {value === 4 && <Settlement handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 5 && <EnquirySubmission handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 6 && <Award handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                        {value === 7 && <ChooseArbitratorForCaseInformation handleChange={this.handleChange} caseData={this.props.caseData}/>}
                                    {this.props.isDesktop && <Footer />}
                            </div>
                        );
                    }
                }
                else{
                    return(
                        <div className={classes.button}>
                            <CircularProgress size={25} thickness={2} className={classes.loading}/>
                        </div>
                    )
                }

                }
            }
        }
    }
//   }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
    isLoading: state.userInfo.isLoading,
    userId: state.auth.userId,
    respondent_docs: state.caseInfo.respondent_docs,
    arbitrator_docs: state.caseInfo.arbitrator_docs,
    claimant_docs: state.caseInfo.claimant_docs,
    admin_docs: state.caseInfo.admin_docs,
    caseId: state.caseInfo.caseId,
    twofa: state.auth.twofa,
    userType: state.caseInfo.userType,
    caseData: state.caseInfo.caseData,
    lang: state.i18nState.lang,
    newAccount: state.caseInfo[`${state.caseInfo.userType}_newAccount`],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCaseInfo: (caseId, uniqueId) =>
      dispatch(actions.getCaseInfo(caseId, uniqueId)),
    getUserInformation: (uniqueId) =>
      dispatch(actions.getUserInformation(uniqueId)),
  };
};

const mapSizesToProps = (sizes) => ({
  isMobile: withSizes.isMobile(sizes),
  isTablet: withSizes.isTablet(sizes),
  isDesktop: withSizes.isDesktop(sizes),
  isGtMobile: withSizes.isGtMobile(sizes),
  isGtTablet: withSizes.isGtTablet(sizes),
  isStTablet: withSizes.isStTablet(sizes),
  isStDesktop: withSizes.isStDesktop(sizes),
  isTabletAndGreater: withSizes.isTabletAndGreater(sizes),
  isTabletAndSmaller: withSizes.isTabletAndSmaller(sizes),
});

MainPanel.contextTypes = {
  t: PropTypes.func,
};

export default connect( mapStateToProps, mapDispatchToProps)(withSizes(mapSizesToProps)(withStyles(styles)(withRouter(MainPanel))));
